module.exports = __webpack_public_path__ + "img/multiple-scenes-client-2.21a1ec01.png";